import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import functionsService from '../../services/Configurator/FunctionsService';
import * as formula from '../../configurator/CalculatedCharacteristics/FunctionsCharacteristics';

const addOrReplaceCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const functionsCharacteristics = s.functionsModel.characteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = functionsCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = functionsCharacteristics.indexOf(filteredCharacteristic[0]);
            functionsCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        functionsCharacteristics.push(characteristic);
    }
};

const getCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.functionsModel.characteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const getNrOfValues = (code: string, s: any) => {
    const filteredCharacteristic = s.functionsModel.characteristics.filter((characteristic: any) => characteristic.code === code)[0];
    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic.values.length;
    } else {
        return 0;
    }
};

const getDefaultState = () => {
    return {
        functionsModel: {
            modelUnlocked: false,
            characteristics: [],
            modelStatus: {
                active: false,
            },
        },
        defaultCharacteristicObject: {
            id: 0,
            description: 'Static Characteristic Description',
            code: 'CHARACTERISTIC_CODE',
            values: [
                {
                    id: 0,
                    description: 'Static Value Description',
                    value: 'No Val',
                    resource: '',
                },
            ],
        },
    }
};

const state = {
    functionsModel: {
        modelUnlocked: false,
        characteristics: [],
        modelStatus: {
            active: false,
        },
    },
    defaultCharacteristicObject: {
        id: 0,
        description: 'Static Characteristic Description',
        code: 'CHARACTERISTIC_CODE',
        values: [
            {
                id: 0,
                description: 'Static Value Description',
                value: 'No Val',
                resource: '',
            },
        ],
    },
};

const getters = {
    getFunctionsCharacteristics: (s: any) => s.functionsModel.characteristics,

    getCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
    getNrOfValuesByCharacteristic: (s: any) => {
        return (characteristicCode: string) => getNrOfValues(characteristicCode, s);
    },
};

const actions = {
    setFunctionsCharacteristics(context: any, payload: any) {
        context.commit('updateFunctionsCharacteristics', payload);
    },

    async setCharacteristicDependencies(context: any, chacrateristicCode: string) {
        var functionModelCharacteristics = context.getters.getFunctionsCharacteristics;
        
        const anchor: any = functionModelCharacteristics.filter(
            (item: any) => item.code === chacrateristicCode)[0];

        const doorConfiguration = context.rootState.configuratorModule.doorConfiguration;

        const filteredDependencies = doorConfiguration.GetDependenciesByCharacteristic(chacrateristicCode);

        await functionsService.extractDependencies(anchor.id, filteredDependencies)

        .then((response: any) => {
            context.commit('updateCharacteristicDependencies', response.data);
        });
    },
    calculateSchallschutzSonder(context: any) {
        const schallschutzSonderValue = formula.calculateSchallschutzSonderCharacteristic();
        if (typeof schallschutzSonderValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Functions, 'KTU_MM_SCHALLSCHUTZ_PLUS', schallschutzSonderValue);
        }
    },
    setConfiguratorCalculatedCharacteristics(context: any) {
        context.commit('updateConfiguratorCalculatedCharacteristics', context.rootState.configuratorModule.doorConfiguration);
    },
    initFunctionsModule(context : any, payload : any)
    {
        context.commit('initFunctionsModule', payload);
    },
    resetState(context : any)
    {
        context.commit('resetState');
    }
};

const mutations = {
    updateFunctionsCharacteristics(s: any, payload: any) {
        s.functionsModel.characteristics = payload.characteristics;
        var st = state;
    },

    updateCharacteristicDependencies(s: any, payload: any) {
        const characteristic = payload.characteristics[0];
        if (typeof characteristic !== 'undefined') {
            addOrReplaceCharacteristic(characteristic, s);
        }
    },
    updateConfiguratorCalculatedCharacteristics(s: any, payload: any) {
        updateCalculatedCharacteristics(payload);
    },
    initFunctionsModule(state : any, payload : any)
    {
        //init FunctionsModule!
    },
    resetState(s: any)
    {
        Object.assign(s, getDefaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

const updateCalculatedCharacteristics = (doorConfiguration: any) => {
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Functions, 'KTU_MM_TUERBLATT_DICKE_NEU', formula.calculateTuerblattDickeNeu());
    doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Functions,'CUST_MM_BANDART',formula.calculateBandArt());
    doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Functions,'KTU_MM_SCHALLSCHUTZ_PLUS',formula.calculateSchallschutzSonderCharacteristic());
};